import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const inputCls =
  "h-10 rounded-lg border-white/15 bg-[#0B1120] text-sm text-slate-100 placeholder:text-slate-500 focus-visible:ring-1 focus-visible:ring-orange-500 focus-visible:ring-offset-0";

export const Field = ({ label, hint, children }) => (
  <div className="space-y-1.5">
    <Label className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">
      {label} {hint && <span className="normal-case tracking-normal text-slate-500">({hint})</span>}
    </Label>
    {children}
  </div>
);

export const SelectField = ({ label, hint, value, onChange, options, placeholder, testId, disabled }) => (
  <Field label={label} hint={hint}>
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testId} className={inputCls}>
        <SelectValue placeholder={placeholder || "Select"} />
      </SelectTrigger>
      <SelectContent className="max-h-72 rounded-none border-white/10 bg-[#0F172A] text-slate-100">
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} className="focus:bg-orange-500/20 focus:text-white">
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </Field>
);
